import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";
import DateManager from "../../shared/dateManager";
import { CoreLogService } from "../../services/log.service";
import * as moment from "moment";
import { BasketItemViewModel, ScheduledForRequest } from "../../shared/models";
import Utils from "../../shared/utils";

interface BasketItemConfigData {
  items: BasketItemViewModel[];
  selectedDay: number;
  selectedTime: number;
  schedule_req: ScheduledForRequest
}

@Component({
  selector: "timeControlDialog",
  templateUrl: "./timeControlDialog.component.html",
  styleUrls: ["./timeControlDialog.component.scss"],
})

export class TimeControlDialogComponent implements OnInit {

  private _itemFromHMS: number = 0;
  private _itemToHMS: number = 0;

  constructor(public bottomSheetRef: MatBottomSheetRef<TimeControlDialogComponent, "remove" | "changeTime">
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: BasketItemConfigData
    , private _webShopService: WebShopService
    , private _coreLanguageService: CoreLanguageService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService) {
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("TimeControlDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** timeset date */
  private _getTimeSetDate(time_set: number) {
    const me = this;
    const hasTimeset = time_set > 0 && me.modalData.schedule_req.time_sets;
    if (hasTimeset) {
      const timesets = me.modalData.schedule_req.time_sets.find(i => i.id === time_set);
      const timesetDate = timesets.days.find((i => i.day === me.modalData.selectedDay));
      return timesetDate;
    } else {
      return null;
    }
  }

  /** 
   * @param time_set time set id : 0 = no group
   * @param schedule_req depending on selected time
   * @param scheduled_to_hms time contol(simple)
   * @returns hms
   */
  public getItemFromHMS(time_set: number, scheduled_from_hms: number) {
    const me = this;
    const timesetDate = me._getTimeSetDate(time_set);
    if (timesetDate) {
      me._itemFromHMS = timesetDate.from_time_hms
    } else {
      me._itemFromHMS = scheduled_from_hms;
    }
    return me._itemFromHMS;
  }

  /**
   * @param time_set time set id : 0 = no group
   * @param schedule_req depending on selected time
   * @param scheduled_to_hms time contol(simple)
   * @returns hms
   */
  public getItemToHMS(time_set: number, scheduled_to_hms: number) {
    const me = this;
    const timesetDate = me._getTimeSetDate(time_set);
    if (timesetDate) {
      me._itemToHMS = timesetDate.to_time_hms;
    } else {
      me._itemToHMS = scheduled_to_hms;
    }
    return me._itemToHMS;
  }

  /** formated price */
  public setItemPrice(item_price: number, item_count: number) {
    const me = this;
    const itemprice = item_price * item_count;
    return me._webShopService.formatCurrency(itemprice);
  }

  /** formated time */
  public getFormatedTime(timeset: number) {
    const formatedTime = DateManager.GetMomentFromInt(0, timeset);
    return formatedTime.format('HH:mm');
  }

  /** check if selected day is current day*/
  public isCurrentDaySelected(selectedDay: number): boolean {
    const currentDay = moment().day();
    return selectedDay === currentDay;
  }

  /** item can be ordered on current day  */
  public isOrderPossibleForCurrentDay(time_set: number, scheduled_to_hms: number) {
    const me = this;
    const itemToHMS = me.getItemToHMS(time_set, scheduled_to_hms)
    const now = moment();
    const currentTimeHMS = Utils.GetHMSFromMoment(now);
    return currentTimeHMS <= itemToHMS;
  }

  /** available order time (from to) */
  public getAnotherdayLabel() {
    const me = this;
    return me._coreLanguageService.value("phTimeCotrolDialog_Scheduled_info_AnotherDay_Order_Time")
      .replace("{fromTime}", `<span class="emphasized">${me.getFormatedTime(me._itemFromHMS)}</span>`)
      .replace("{toTime}", `<span class="emphasized">${me.getFormatedTime(me._itemToHMS)}</span>`)
  }

  /** item cann't be booked on another day */
  public noOrderForAnotherDay(time_set: number, scheduled_from_hms: number, scheduled_to_hms: number) {
    const me = this;
    const hasFromHMS = !Utils.IsNull(me.getItemToHMS(time_set, scheduled_from_hms))
    const hasToHMS = !Utils.IsNull(me.getItemFromHMS(time_set, scheduled_to_hms))
    return hasToHMS || hasFromHMS;
  }

  /** no order possible for selected  time */
  public noOrderPossibleForSelectedTime(selectedTime: number) {
    const me = this;
    const selectedFormatedTime = me.getFormatedTime(selectedTime)
    return me._coreLanguageService.value("phTimeCotrolDialog_No_Order_Possible_For_Selected_Time")
      .replace("{time}", `<span class="emphasized">${selectedFormatedTime}</span>`);
  }

  /** remove basket item */
  public removeItemFromBasket() {
    const me = this;
    me.bottomSheetRef.dismiss("remove");
  }

  // change selected time
  public changeTime() {
    const me = this;
    me.bottomSheetRef.dismiss("changeTime");
  }
}
